/**
 * Send instant and IANA zone of the browser doing the sending, so the AI turn
 * can state the sender's wall clock rather than the server's.
 */
export function clientSendContext(): {
  clientSentAt: number;
  clientTimezone: string;
} {
  return {
    clientSentAt: Date.now(),
    clientTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}
